export default "__VITE_ASSET__6955f7fa__"